var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSGreenLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 136,
    viewBox: "0 0 107 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.88477 95.8979L34.8576 86.6792C36.7981 86.1186 38.7476 87.3078 39.4693 89.3572C41.8931 96.236 47.8846 100.167 55.719 99.5269C62.8657 98.9413 67.1846 94.7586 66.7874 88.9464C65.3077 67.2998 3.55654 80.4153 0.869441 41.13C-0.596663 19.6832 17.7977 3.06353 45.2815 0.814443C72.148 -1.38471 93.5313 11.4653 98.5424 32.2222C99.078 34.4463 97.9546 36.7431 95.9415 37.4058L65.4597 47.4415C63.5329 48.0747 61.5357 46.9582 60.7618 44.9269C58.4719 38.9082 53.9715 35.5765 48.4271 36.0304C42.9303 36.4798 39.4852 39.9885 39.812 44.7976C41.1828 64.8419 103.218 50.4918 106.07 92.1827C107.648 115.232 87.8666 133.177 57.4529 135.667C27.5634 138.113 4.49839 124.047 0.0773818 100.755C-0.3334 98.5918 0.932987 96.4653 2.88704 95.9024L2.88477 95.8979Z",
    fill: "#8ABEAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSGreenLetter);
export default __webpack_public_path__ + "static/media/s-green-letter.b0b614b44a6860ce2d2792db4ca7c7a9.svg";
export { ForwardRef as ReactComponent };